"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIsUnloadingForTesting = exports.makeBeforeSendHook = void 0;
var Sentry = __importStar(require("@sentry/browser"));
var browser_1 = require("@sentry/browser");
var Integrations = __importStar(require("@sentry/integrations"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var eventHook_1 = require("./eventHook");
var wrappedFetchTransport_1 = require("./wrappedFetchTransport");
var missing = 'missing';
var pageIsUnloading = false;
function isBotEvent(event) {
    var _a;
    return String((_a = event === null || event === void 0 ? void 0 : event.tags) === null || _a === void 0 ? void 0 : _a.is_bot) === 'true';
}
/* Identify failed network requests triggered by bot user agents
 */
function isBotNetworkError(event) {
    var _a, _b;
    if (!isBotEvent(event)) {
        return false;
    }
    var values = ((_a = event === null || event === void 0 ? void 0 : event.exception) === null || _a === void 0 ? void 0 : _a.values) || [];
    var hasNetworkInValue = false;
    for (var i = 0; i < values.length; i++) {
        if (values[i].value === 'Network request failed') {
            hasNetworkInValue = true;
        }
    }
    var hasNetworkInMessage = ((_b = event === null || event === void 0 ? void 0 : event.message) === null || _b === void 0 ? void 0 : _b.indexOf('Network request failed')) !== -1;
    return hasNetworkInMessage || hasNetworkInValue;
}
var initSentry = function (sentryOpts, initOpts) {
    if (initOpts.loggingApiHost) {
        wrappedFetchTransport_1.setApiHost(initOpts.loggingApiHost);
    }
    var defaultOpts = {
        blacklistUrls: [
            /cdn\.speedcurve\.com/,
            /cdn\.branch\.io/,
            /fbcdn\.net/,
            /spdcrv\.global\.ssl\.fastly\.net/,
        ],
        transport: wrappedFetchTransport_1.WrappedFetchTransport,
        integrations: [new Integrations.Dedupe()],
    };
    var opts = __assign(__assign(__assign({}, defaultOpts), sentryOpts), { beforeSend: makeBeforeSendHook(sentryOpts.beforeSend) });
    if (!opts.dsn || !opts.release) {
        throw new Error('dsn and release need to be set to properly configure sentry.');
    }
    Sentry.init(opts);
    Sentry.configureScope(function (scope) {
        scope.setTag('is_production_test', getIsUem());
        scope.setTag('tracking_id', js_cookie_1.default.get('firstTimeVisitor') || missing);
        scope.setTag('session_id', getSessionIdOrMissingFromBsid());
        scope.setTag('application_name', initOpts.appName);
        scope.setTag('application_version', opts.release);
        scope.setTag('pageview_id', initOpts.pageviewId || missing);
        scope.setTag('logger', 'javascript');
    });
    addIFrameTags();
    addEventListeners();
};
function makeBeforeSendHook(customBeforeSend) {
    return function (event, hint) {
        // We use this to filter out any network errors which occurred due to page unload.
        if (pageIsUnloading) {
            return null;
        }
        // Skip failed network requests triggered by bot user agents
        if (isBotNetworkError(event)) {
            return null;
        }
        event = eventHook_1.customFingerprintHook(event, hint);
        if (typeof event.tags === 'undefined') {
            event.tags = {};
        }
        if (!event.tags['pageType']) {
            var tag = 'unknown';
            // @ts-ignore
            if (typeof window !== 'undefined' && window['__PAGE_TYPE__']) {
                // @ts-ignore
                tag = window['__PAGE_TYPE__'];
            }
            event.tags['pageType'] = tag;
        }
        if (customBeforeSend) {
            return customBeforeSend(event, hint);
        }
        return event;
    };
}
exports.makeBeforeSendHook = makeBeforeSendHook;
var getSessionIdOrMissingFromBsid = function () {
    var bsid = js_cookie_1.default.get('bsid');
    if (!bsid) {
        return missing;
    }
    var session_id = bsid.split('_')[0];
    return session_id;
};
var getIsUem = function () {
    var hasUemCookie = js_cookie_1.default.get('ZD-ProductionTest');
    var hasUemUA = navigator.userAgent.toLowerCase().indexOf('zd-productiontest') > 0;
    return String(hasUemCookie != null || hasUemUA);
};
function addEventListeners() {
    if (!window) {
        return;
    }
    /**
     * We will use this to disable sentry reporting for these errors.
     * We set it on beforeunload because we might not have time to hit this on unload.
     */
    window.addEventListener('beforeunload', function () {
        pageIsUnloading = true;
        // re-enable sentry after 30s if the page is still active
        setTimeout(function () {
            pageIsUnloading = false;
        }, 30000);
        Sentry.addBreadcrumb({
            level: browser_1.Severity.Info,
            message: 'window.beforeunload',
        });
    });
    window.addEventListener('unload', function () {
        Sentry.addBreadcrumb({
            level: browser_1.Severity.Info,
            message: 'window.unload',
        });
    });
    window.addEventListener('online', function () {
        Sentry.addBreadcrumb({
            level: browser_1.Severity.Info,
            message: 'network changed: online',
        });
    });
    window.addEventListener('offline', function () {
        Sentry.addBreadcrumb({
            level: browser_1.Severity.Info,
            message: 'network changed: offline',
        });
    });
}
function addIFrameTags() {
    var isIFrame = isDocumentInIframe();
    var host = window.location.host;
    if (isIFrame) {
        var queryParams = parseUrlParams();
        // For sites that we intentionally IFrame (vanity urls) we add a query parameter
        // that contains the hostname https://github.com/Zocdoc/zocdoc_web/blob/67404b5b410903fbd7519826da5a81f8d7b103bd/ProfileiFramer/Default.aspx.cs#L90
        if ('host' in queryParams) {
            host = queryParams['host'];
        }
    }
    Sentry.configureScope(function (scope) {
        scope.setTag('is_iframe', isIFrame.toString().toLowerCase());
        scope.setTag('http_host', host.toLowerCase());
    });
}
function isDocumentInIframe() {
    // https://stackoverflow.com/a/326076
    try {
        return window.self !== window.top;
    }
    catch (e) {
        // some browsers throw on cross origin frame access
        return true;
    }
}
function parseUrlParams(url) {
    url = url || window.location.search;
    var query = url.substr(1);
    var result = {};
    query.split('&').forEach(function (part) {
        var item = part.split('=');
        var key = item[0].toLowerCase();
        result[key] = decodeURIComponent(item[1]);
    });
    return result;
}
function setIsUnloadingForTesting(isUnloading) {
    pageIsUnloading = isUnloading;
}
exports.setIsUnloadingForTesting = setIsUnloadingForTesting;
exports.default = initSentry;
//# sourceMappingURL=index.js.map